import { use } from 'react';

import { DialogContext } from '../providers/dialog-context-providers';

export const useDialogContext = () => {
   const context = use(DialogContext);
   if (!context) {
      throw new Error('useDialogContext must be used within a DialogContext');
   }
   return context;
};
